<ng-content select="[locationDisplayCards]"></ng-content>
<ng-content select="[companyDisplayCards]"></ng-content>

<div class="wccard mb-1 p-3">
  <div class="d-flex">
    <ng-content select="[talentPoolBulkGrab]"></ng-content>
    <div>
      <div class="circular-img mr-4 mb-3 text-capitalize position-relative" [ngClass]="{
                'lavender-circle': i % 4 == 0,
                'yellow-circle': i % 4 == 1,
                'blue-circle': i % 4 == 2,
                'teal-circle': i % 5 == 3
              }">{{transform(data.full_name_with_middle_name).charAt(0)}}
        <span class="viewed-profile position-absolute" *ngIf="data && data.lastseencount >=1">Viewed</span>
      </div>
    </div>

    <div class="d-flex justify-content-between w-100">
      <div>
        <span class="d-inline-flex align-items-center mb-1">
          <span class="f-16 font-weight-600 pointer text-webbtree-green mr-2" (click)="handleChildEvents('openNav')"
            [innerHTML]="transform(data.full_name_with_middle_name)" *ngIf="data?.full_name_with_middle_name">
          </span>

          <span class="similarity pointer d-inline-flex align-items-center" *ngIf="isSimilarCandidate"
            (click)="openSimilarityInsights()">
            <i class="fa-solid fa-stars mr-1"></i>
            Similarity Insights
          </span>
           <span class="similarity pointer d-inline-flex align-items-center" *ngIf="isComingFromJD"
            (click)="openJDInsights()">
            <i class="fa-solid fa-stars mr-1"></i>
            JD Fit Insights
          </span>
        </span>

        <p class="f-16 icon-color mb-1 f-14 position-relative">
          <span class="" (mouseenter)="getCompanyInfo('main',null, $event)" *ngIf="currentJobTitle">

            <span *ngIf="currentJobTitle" class="text-capitalize"
              [innerHTML]="highlightInfo(currentJobTitle, 'currentjobtitle')"></span>
            <span *ngIf="currentJobTitle && currentCompany"> at </span>
            <span *ngIf="currentCompany" class="position-relative text-capitalize"
              [ngClass]="{'dstooltip pointer':primaryCompanyInformation?.website, companyHover: primaryCompanyInformation?.website}">
              <span [innerHTML]="highlightInfo(currentCompany, 'currentcompany')"></span>
              <span class="dstooltip-content">
                <app-company-hover-modal [companyInformation]="primaryCompanyInformation"
                  *ngIf="primaryCompanyInformation"></app-company-hover-modal>
              </span>
            </span>
          </span>
          <span *ngIf="!currentJobTitle && currentSchool" class="text-capitalize">Student at {{currentSchool}}</span>
        </p>
        <p class="f-12 mb-1 d-flex align-items-center" style="width: 570px;">
          <i class="far fa-map-marker-alt mr-1 text-9696" *ngIf="currentLocation"></i>
          <span *ngIf="currentLocation" [innerHTML]="highlightInfo(currentLocation, 'location')" matTooltip="{{'Location: '+currentLocation}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"
            class="text-9696 text-capitalize text-truncate"></span>
          <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
            *ngIf="currentLocation && totalTenure"></i>
          <span *ngIf="totalTenure" matTooltip="{{'Total years of experience: '+ totalTenure}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"
            class="text-9696 text-nowrap">
            <i class="far fa-briefcase mr-1" *ngIf="totalTenure"></i>
            <span *ngIf="totalTenure" class="text-9696">{{totalTenure}}</span>
          </span>

          <i class="fas fa-circle text-d9d9d9 mx-2 mr-1 text-9696" style="font-size:5px"
            *ngIf="totalTenure && data?.job_company_industry"></i>

          <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
            *ngIf="currentLocation && !totalTenure && data?.job_company_industry"></i>
          <span *ngIf="data?.job_company_industry" matTooltip="{{'Current Industry: '+data?.job_company_industry}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"
            class="text-9696 text-truncate">
            <i class="fa-sharp fa-regular fa-industry-windows mr-1" *ngIf="data?.job_company_industry"></i>
            <!-- <span *ngIf="data?.job_company_industry" class="text-9696">{{truncateString(data?.job_company_industry |
                            titlecase)}}</span> -->
            <span  class="text-9696">{{data?.job_company_industry |
              titlecase}}</span>
          </span>
          <!-- Commented as per product -->
          <!-- <i class="fas fa-circle text-d9d9d9 mx-2 mr-1 text-9696" style="font-size:5px"
            *ngIf="currentLocation && !data?.job_company_industry && !totalTenure && positionCategories"></i>

          <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
            *ngIf="!currentLocation && totalTenure && !data?.job_company_industry && positionCategories"></i>
            <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
            *ngIf="totalTenure && !data?.job_company_industry && positionCategories"></i>
          <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
            *ngIf="data?.job_company_industry && positionCategories"></i>
          <span matTooltip="Webbtree True Level" [matTooltipClass]="{ 'red-tooltip text-black': true }"
            class="text-9696 text-truncate">
            <i class="fa-solid fa-user-tie mr-1" *ngIf="positionCategories"></i>
            <span *ngIf="positionCategories" class="text-9696">{{positionCategories |
              titlecase}}</span>
          </span> -->
          <!-- <i class="fas fa-circle text-d9d9d9 mx-2 mr-1 text-9696" style="font-size:5px"
                        *ngIf="data?.job_company_industry && (linkedin_url || twitter_url || facebook_url)"></i>

                    <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
                        *ngIf="totalTenure && !data?.job_company_industry && (linkedin_url || twitter_url || facebook_url)"></i>
                    <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
                        *ngIf="currentLocation && !data?.job_company_industry && !totalTenure && (linkedin_url || twitter_url || facebook_url)"></i> -->

          <!-- <a data-testid="auto-app-candidate-quick-view-a-1" target="_blank" rel="noopener noreferrer" *ngIf="linkedin_url"
                        (click)="openUrl(linkedin_url, 'linkedin')" class="mr-2">

                        <i class="fa fa-linkedin-square f-16" aria-hidden="true" style="color: #0652ba;"></i>

                    </a>

                    <a data-testid="auto-app-candidate-quick-view-a-2" target="_blank" rel="noopener noreferrer" *ngIf="twitter_url && !isBoolean(twitter_url)"
                        (click)="openUrl(twitter_url, 'twitter')" class="mr-2">

                        <i class="fa-brands fa-square-x-twitter f-16" style="color: #4ca7fc;"></i>
                    </a>
                    <i class="fa-brands fa-square-x-twitter text-9696" style="height: 14px; margin-right: 10px;" alt="Twitter"
                        title="Twitter" *ngIf="isBoolean(twitter_url) && twitter_url" alt="Twitter" title="Twitter"></i>
                    <a data-testid="auto-app-candidate-quick-view-a-3" target="_blank" rel="noopener noreferrer" *ngIf="github_url && !isBoolean(github_url)"
                        (click)="openUrl(github_url, 'github')" class="mr-2">
                        <i class="fab fa-github f-16" style="color: black;"></i>
                    </a>

                    <a data-testid="auto-app-candidate-quick-view-a-4" target="_blank" rel="noopener noreferrer" *ngIf="facebook_url && !isBoolean(facebook_url)"
                        (click)="openUrl(facebook_url, 'facebook')" class="mr-2">
                        <i class="fab fa-facebook f-16" style="color: #1773ea;"></i>
                    </a>
                    <i class="fab fa-facebook-square text-9696" style="height: 14px; margin-right: 10px;"
                        *ngIf="isBoolean(facebook_url) && facebook_url" alt="Facebook" title="Facebook"></i> -->
        </p>
      </div>

      <!-- <div class="text-right">
                <ng-content select="[addToTalentPool]"></ng-content>
                <div class="dstooltip">
                    <span (mouseenter)="print()" class="skills-chip px-2 py-1 mb-1 text-capitalize f-14 pointer">Source</span>
                      <span class="dstooltip-content source-div-style">
                       <app-source-hover-modal [profileInformation]="temp"></app-source-hover-modal>
                      </span>
                  </div>
            </div> -->
      <div class="d-flex">
        <ng-content select="[addToTalentPool]"></ng-content>
        <span class="dropdown ats-dropBtn ml-2 mt-1" *ngIf="parent !== 'TalentpoolRecommendedCandidateListComponent'">
          <button data-testid="auto-app-candidate-quick-view-button-1" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
            appDropdownToggle aria-haspopup="true" aria-expanded="false" style="margin-right: -12px;">
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="userDropdownButton">
            <a data-testid="auto-app-candidate-quick-view-a-5" class="dropdown-item f-12 isActive px-3" routerLinkActive="active" (click)="redirecttoSimilarList()"><i
                class="fa-solid fa-user-group mr-2"></i>View
              Similar Candidates</a>
            <a data-testid="auto-app-candidate-quick-view-a-6" class="dropdown-item f-12 isActive px-3" routerLinkActive="active" (click)="openAddToEmailCampaign()"> <i
                class="fa-solid fa-envelopes-bulk mr-2"></i>Add to
              Email Campaign </a>
            <a data-testid="auto-app-candidate-quick-view-a-7" class="dropdown-item f-12 isActive px-3" routerLinkActive="active" (click)="openAddToScreenAiModal()">
              <i class="fa-solid fa-globe mr-2"></i>Add to ScreenAI
            </a>
          </div>
        </span>
      </div>

    </div>
  </div>

  <!-- <ng-container *ngIf="(!!highlights.talentIndustries.length && highlights.talentIndustries.length > 1) || highlights.isTechie"> -->
  <ng-container *ngIf="highlightsList?.length">
    <div class="d-flex align-items-baseline">
      <div class="d-flex justify-content-end w-100px">
        <!--  *ngIf="canShowContactText == false" -->
        <span class="text-9696 mr-3 f-12">Highlights</span>
      </div>

      <div class="d-flex flex-wrap removengbtooltiparrow">
        <!-- Hignlights Chips -->
        <div *ngFor="let highlight of highlightsList.slice(0, 4)" class="highlight-pill"
          [ngClass]="'highlight-pill-' + highlight.color" [ngbTooltip]="highlight_chip_tooltip" placement="bottom">

          <i class="fa-solid fa-building mr-2" [ngClass]="'briefcase-blank-' + highlight.color" *ngIf="!highlight?.imageName"></i>
          <span *ngIf="highlight?.imageName">
            <img [src]="'assets/highlights/' + highlight.imageName + '.svg'" alt="">
          </span>
          <span class="ml-2">{{ highlight.label }}</span>

          <ng-template #highlight_chip_tooltip>
            <span class=" f-12">
              <span class="">

                <div
                  *ngIf="highlight.label !== 'Multi-Industry' && highlight.label !== 'Techie' && highlight.label !== 'Promotion Track' && highlight.label !== 'Unicorn Experience'
                                                    && highlight.label !== 'Same Location' && highlight.label !== 'Nearby Location' && highlight.label !== 'Role Compatibility'
                                                    && highlight.label !== 'Years of Experience' && highlight.label !== 'Company Size' && highlight.label !== 'Skills Matched'">
                  <div class="hiderule">
                    <div class="position-relative">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">
                        Candidate has {{ highlight.label.toLowerCase() }} :
                        <span class="f-12 font-weight-600 fw-600" *ngFor="let item of highlight.value; let last = last">
                          {{ item | titlecase }}{{ !last ? ', ' : '.' }}
                        </span>
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Techie'">
                  <div class="hiderule">
                    <div class="position-relative">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">
                        Activity noticed on technology social networks like: GitHub, Stack Overflow,
                        Kaggle, etc.
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Multi-Industry'">
                  <div class="hiderule" *ngFor="let item of highlight.value">
                    <div class="position-relative">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Worked in <span class="fw-600">{{item.name
                          |
                          capitalizeFirstLetter}}</span>
                        <span class="font-weight-normal f-12" *ngIf="item.exp.year || item.exp.month"> for </span>
                        <span class="font-weight-normal f-12" *ngIf="item.exp.year">{{(item.exp.year
                          == 1)? (item.exp.year +" Year"):(item.exp.year+" Years")}} </span>
                        <span class="font-weight-normal f-12" *ngIf="item.exp.year && item.exp.month">and </span>
                        <span class="font-weight-normal f-12" *ngIf="item.exp.month">{{(item.exp.month == 1)?
                          (item.exp.month +"
                          Month"):(item.exp.month+" Months")}} </span>
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Promotion Track'">
                  <div class="hiderule">
                    <div class="position-relative"
                      *ngIf="highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at both current and previous
                        companies.</span>
                    </div>
                    <div class="position-relative"
                      *ngIf="highlight.value?.currentjob_internal_movement && !(highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement)">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at current company.</span>
                    </div>
                    <div class="position-relative"
                      *ngIf="highlight.value?.progression_within_pastcompany && !(highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement)">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at previous company.</span>
                    </div>
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Unicorn Experience'">
                  <div class="hiderule">
                    <div class="position-relative">
                      <span class="dot custom-tooltip"></span>
                      <span class="font-weight-normal f-12 hl-mssg">
                        Candidate has experience in a Unicorn company :
                        <span class="f-12 font-weight-600 fw-600" *ngFor="let item of highlight.value; let last = last">
                          {{ capitalizeFirstLetter(item) }}{{ !last ? ', ' : '.' }} </span>
                        </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Same Location' || highlight.label === 'Nearby Location'">
                  <div class="hiderule">
                    <div>
                      <span class="font-weight-normal f-12 hl-mssg custom-tooltip"> This Candidate’s current location
                        <span class="text-capitalize" [innerHTML]="highlight.value"></span>
                        matches with your ideal profile.
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Role Compatibility' || highlight.label === 'Years of Experience'">
                  <div class="hiderule">
                    <div>
                      <span *ngIf="highlight.label === 'Role Compatibility'" class="font-weight-normal f-12 hl-mssg">The
                        candidate's
                        job
                        title as a <span class="font-weight-600 text-capitalize" [innerHTML]="highlight.titles"></span> aligns
                        with a
                        closely matching
                        profile.
                      </span>

                      <span *ngIf="highlight.label === 'Years of Experience'" class="font-weight-normal f-12 hl-mssg">The
                        candidate
                        possesses over <span [innerHTML]="totalTenure"></span> years of
                        experience, which
                        closely aligns with your preferred profile.
                      </span>

                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

                <div *ngIf="highlight.label === 'Company Size' || highlight.label === 'Skills Matched'">
                  <div class="hiderule">
                    <div>

                      <span *ngIf="highlight.label === 'Company Size'" class="font-weight-normal f-12 hl-mssg"> This
                        candidates
                        has
                        worked in a
                        similar company size i.e. <span [innerHTML]="highlight.value"></span> in
                        the past.
                      </span>

                      <span *ngIf="highlight.label === 'Skills Matched'" class="font-weight-normal f-12 hl-mssg"> <span
                          class="text-capitalize" [innerHTML]="highlights.skills"></span>
                        skills present in this candidate that matches with your ideal profile.
                      </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                </div>

              </span>
            </span>
          </ng-template>
        </div>

      </div>

      <p class="f-12 text-webbtree-green pointer" *ngIf="highlightsList && highlightsList.length > 4" (click)="openSliderSection(null, 'show-skills')">+ {{highlightsList.length - 4}} more</p>
      </div>
  </ng-container>

  <!-- contacts -->
  <div class="d-flex mt-2 align-items-baseline" *ngIf="parent !== 'TalentpoolRecommendedCandidateListComponent'">
    <div class="d-flex justify-content-end w-100px">
      <!--  *ngIf="canShowContactText == false" -->
      <span class="text-9696 mr-3 f-12">Contact</span>
    </div>

    <!-- <app-candidate-quick-view-contact [candidateInfo] = "data" [currrentIndex] = "i" (openSlider)="openContact()" style="width: 100%;" (hideContactText)="hideContactText()"></app-candidate-quick-view-contact> -->
    <app-candidate-quick-view-contact [candidateInfo]="data" [currrentIndex]="i"
      (openSlider)="openSliderSection($event, 'show-contact')" style="width: 100%;"></app-candidate-quick-view-contact>

  </div>


  <div class="d-flex align-items-baseline mt-1">

    <div class="d-flex" style="width: 114px;">
    </div>

    <div class="d-flex" *ngIf="showMoreContactDetails">
      <p class="f-12 text-webbtree-green pointer mb-2" (click)="openSliderSection(null, 'show-contact')"><img
          src="../../assets/icons/file-circle-info.png" alt="" style="height: 14px;"> Looking for more contact
        details?</p>
    </div>
  </div>

  <!-- contacts -->
  <!-- <div *ngIf="hasRevealableInfo && !revealContact || true" class="d-flex mt-2 align-items-baseline">
        <div class="d-flex justify-content-end w-100px">
            <span class="text-9696 mr-3 f-12">Contact</span>
        </div>
        <div class="d-flex justify-content-between w-100">
            <div class="mb-2 f-12 d-flex align-items-baseline">
                <span class="d-flex">
                    <span class="d-flex flex-column mr-4" *ngIf="revealableInfoObj?.mobile_phone?.length">
                        <span *ngFor="let phone of revealableInfoObj?.mobile_phone" class="d-flex align-items-baseline">
                            <i [ngClass]="phone.icon" class="mx-1 text-9696"
                            [title]="phone.text"></i>
                            <span class="f-14 font-weight-500">{{ phone?.data[0] }}</span>
                        </span>
                    </span>
                    <span class="d-flex flex-column mr-4" *ngIf="revealableInfoObj?.work_email?.length">
                        <span *ngFor="let email of revealableInfoObj?.work_email" class="d-flex align-items-baseline">
                            <i [ngClass]="email.icon" class="mx-1 text-9696"
                            [title]="email.text"></i>
                            <span class="f-14 font-weight-500">{{ email?.data[0] }}</span>
                        </span>
                    </span>
                    <span class="d-flex flex-column mr-4" *ngIf="revealableInfoObj?.personal_email?.length">
                        <span *ngFor="let email of revealableInfoObj?.personal_email" class="d-flex align-items-baseline">
                            <i [ngClass]="email.icon" class="mx-1 text-9696"
                            [title]="email.text"></i>
                            <span class="f-14 font-weight-500">{{ email?.data[0] }}</span>
                        </span>
                    </span>
                </span>
            </div>
        </div>
    </div> -->

  <!-- current experience -->

  <div class="d-flex align-items-baseline" *ngIf="currentJobTitle || currentCompany">
    <div class="d-flex justify-content-end w-100px">
      <span class="text-9696 mr-3 f-12">Current Exp.</span>
    </div>
    <div class="w-100">
      <div class="mb-2 f-14 d-flex align-items-center flex-wrap">
        <span class="position-relative">
          <span class="f-14 text-capitalize" *ngIf="currentJobTitle"
            [innerHTML]="highlightInfo(currentJobTitle, 'currentjobtitle')">
          </span>
          <span *ngIf="currentJobTitle && currentCompany"> at </span>
          <span class="position-relative text-capitalize" (mouseenter)="getCompanyInfo('main',null, $event)"
            [ngClass]="{'companyHover': primaryCompanyInformation?.website, 'dstooltip pointer':primaryCompanyInformation?.website}">
            <span [innerHTML]="highlightInfo(currentCompany, 'currentcompany')"></span>
            <span class="dstooltip-content">
              <app-company-hover-modal [companyInformation]="primaryCompanyInformation"
                *ngIf="primaryCompanyInformation"></app-company-hover-modal>
            </span>
          </span>
        </span>
        <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
          *ngIf="(currentJobTitle || currentCompany) && currentexplocation" style="font-size:5px"></i>
        <span>
          <span class="text-9696 text-capitalize f-12" *ngIf="currentexplocation"
            [innerHTML]="highlightInfo(currentexplocation, 'location')"></span>
        </span>
        <span *ngIf="currentStartDate" class="d-flex align-items-center f-12">
          <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green" style="font-size:5px"></i>
          <span class="text-9696">{{currentStartDate | moment: 'YYYY'}}
            <span>
              - Current
            </span>
            <!-- <span *ngIf="currentTenure">
                            ({{currentTenure}})
                        </span> -->
          </span>
        </span>
      </div>
    </div>
  </div>

  <!-- past experience -->

  <div class="d-flex" *ngIf="clonedExperience?.length > 0 && isPastExperienceToBeShown">
    <div class="d-flex justify-content-end w-100px">
      <span class="text-9696 mr-3 f-12">Past Exp.</span>
    </div>
    <div class="w-100" id="exp_less{{i}}" style="width: 80%;">
      <div class="mb-2 f-14 position-relative " style="display: block;"
        *ngFor="let exp of clonedExperience | slice:0:2; let j = index">
        <!-- <span> -->
        <span class="f-14 text-capitalize" *ngIf="exp?.title?.name"
          [innerHTML]="highlightInfo(exp?.title?.name, 'past_jobtitle')">
        </span>
        <span *ngIf="exp?.title?.name && exp?.company?.name"> at </span>
        <span (mouseenter)="getCompanyInfo('past',exp, $event)" class="text-capitalize"
          [ngClass]="{companyHover: exp?.company?.website, 'dstooltip pointer':exp?.company?.website}">
          <span [innerHTML]="highlightInfo(exp?.company?.name, 'pastcompany')"></span>
          <span class="dstooltip-content">
            <app-company-hover-modal [companyInformation]="currentCompanyInformation" *ngIf="currentCompanyInformation">
            </app-company-hover-modal>
          </span>
        </span>
        <!-- </span> -->
        <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
          *ngIf="(exp?.title?.name || exp?.company?.name) && exp?.location_names?.length > 0" style="font-size:5px"></i>
        <!-- <span> -->
        <span class="text-9696 text-capitalize f-12" *ngIf="exp?.location_names?.length > 0"
          [innerHTML]="highlightInfo(exp?.location_names[0], 'location')"></span>
        <!-- </span> -->
        <span *ngIf="exp?.start_date && (exp?.end_date || exp.is_primary == true)" class="f-12">
          <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
            *ngIf="exp?.start_date && (exp?.end_date || exp.is_primary == true)" style="font-size:5px"></i>
          <!-- <span> -->
          <span class="text-9696" *ngIf="exp?.start_date">{{exp?.start_date | moment: 'YYYY'}} </span>
          <span class="text-9696" *ngIf="exp?.end_date">
            - {{exp?.end_date | moment: 'YYYY'}}
          </span>
          <span class="text-9696" *ngIf="exp?.is_primary == true">
            - Current
          </span>
          <!-- <span class="text-9696" *ngIf="exp?.totaltenure">
                        ({{exp?.totaltenure}})
                    </span> -->

          <!-- </span> -->
        </span>
        <span *ngIf="clonedExperience?.length > 2 && j == 1" class="f-12 text-webbtree-green pointer ml-2"
          (click)="viewmoredetails('exp', i , 'viewmore')">
          + {{clonedExperience?.length - 2}} more
        </span>
      </div>
    </div>
    <div class="w-100" id="exp_more{{i}}" style="display: none;">
      <div class="mb-2" style="display: block;" *ngFor="let exp of clonedExperience; let x = index">
        <span class="f-14 text-capitalize" *ngIf="exp?.title?.name"
          [innerHTML]="highlightInfo(exp?.title?.name, 'past_jobtitle')"></span>
        <span *ngIf="exp?.title?.name && exp?.company?.name"> at </span>
        <span (mouseenter)="getCompanyInfo('past',exp, $event)"
          [ngClass]="{companyHover: exp?.company?.website, 'dstooltip pointer':exp?.company?.website}">
          <span class="text-capitalize" [innerHTML]="highlightInfo(exp?.company?.name, 'pastcompany')"></span>
          <span class="dstooltip-content">
            <app-company-hover-modal [companyInformation]="currentCompanyInformation" *ngIf="currentCompanyInformation">
            </app-company-hover-modal>
          </span>
        </span>
        <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
          *ngIf="(exp?.title?.name || exp?.company?.name) && exp?.location_names?.length > 0" style="font-size:5px"></i>
        <span class="text-9696 text-capitalize f-12" *ngIf="exp?.location_names?.length > 0"
          [innerHTML]="highlightInfo(exp?.location_names[0], 'location')"></span>
        <span *ngIf="exp?.start_date && (exp?.end_date || exp.is_primary == true)" class="f-12">
          <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
            *ngIf="exp?.start_date && (exp?.end_date || exp.is_primary == true)" style="font-size:5px"></i>
          <span class="text-9696" *ngIf="exp?.start_date">{{exp?.start_date | moment: 'YYYY'}} </span>
          <span class="text-9696" *ngIf="exp?.end_date">
            - {{exp?.end_date | moment: 'YYYY'}}
          </span>
          <span class="text-9696" *ngIf="exp?.is_primary == true">
            - Current
          </span>
          <!-- <span class="text-9696" *ngIf="exp?.totaltenure">
                        ({{exp?.totaltenure}})
                    </span> -->
        </span>
        <span *ngIf="x == clonedExperience?.length-1" class="f-12 text-webbtree-green pointer ml-2"
          (click)="viewmoredetails('exp', i , 'less')">
          view less
        </span>
      </div>
    </div>
  </div>

  <!-- education -->
  <div class="d-flex" *ngIf="data?.education?.length">
    <div class="d-flex justify-content-end w-100px">
      <span class="text-9696 mr-3 f-12">Education</span>
    </div>
    <div class="w-100" id="edu_less{{i}}" style="width: 80%;">
      <div class="mb-2 f-14 " style="display: block;" *ngFor="let exp of data?.education | slice:0:2; let j = index">
        <span class="f-14" *ngIf="exp?.newField" [innerHTML]="transform(exp?.newField)">
        </span>
        <span *ngIf="exp?.newField && exp?.school?.name"> at </span>
        <span [innerHTML]="transform(exp?.school?.name)"></span>

        <i class="fas fa-circle text-d9d9d9 mx-1 text-webbtree-green"
          *ngIf="(exp?.newField || exp?.school?.name) && exp?.school?.location?.name" style="font-size:5px"></i>

        <span class="text-9696  text-capitalize f-12" *ngIf="exp?.school?.location?.name"
          [innerHTML]="highlightInfo(exp?.school?.location?.name, 'location')"></span>
        <span *ngIf="exp?.start_date && (exp?.end_date || exp.is_primary == true)" class="f-12">
          <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
            *ngIf="exp?.start_date && (exp?.end_date || exp.is_primary == true)" style="font-size:5px"></i>

          <span class="text-9696" *ngIf="exp?.start_date">{{exp?.start_date | moment: 'YYYY'}} </span>
          <span class="text-9696" *ngIf="exp?.end_date">
            - {{exp?.end_date | moment: 'YYYY'}}
          </span>
          <span class="text-9696" *ngIf="exp?.is_primary == true">
            - Current
          </span>
        </span>
        <span *ngIf="data?.education?.length > 2 && j == 1" class="f-12 text-webbtree-green pointer ml-2"
          (click)="viewmoredetails('edu', i , 'viewmore')">
          + {{data?.education?.length - 2}} more
        </span>
      </div>
    </div>
    <div class="w-100" id="edu_more{{i}}" style="width: 80%; display: none;">
      <div class="mb-2" style="display: block;" *ngFor="let exp of data?.education; let x = index">
        <!-- <span> -->
        <span class="f-14" *ngIf="exp?.newField" [innerHTML]="transform(exp?.newField)"></span>
        <span *ngIf="exp?.newField && exp?.school?.name"> at </span>
        <span [innerHTML]="transform(exp?.school?.name)"></span>
        <!-- </span> -->
        <i class="fas fa-circle text-d9d9d9 mx-1 text-webbtree-green"
          *ngIf="(exp?.newField || exp?.school?.name) && exp?.school?.location?.name" style="font-size:5px"></i>
        <!-- <span> -->
        <span class="text-9696 f-12" *ngIf="exp?.school?.location?.name"
          [innerHTML]="transform(exp?.school?.location?.name)"></span>
        <!-- </span> -->
        <span *ngIf="exp?.start_date && (exp?.end_date || exp.is_primary == true)" class="f-12">
          <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
            *ngIf="exp?.start_date && (exp?.end_date || exp.is_primary == true)" style="font-size:5px"></i>
          <!-- <span> -->
          <span class="text-9696" *ngIf="exp?.start_date">{{exp?.start_date}}</span>
          <span class="text-9696" *ngIf="exp?.end_date">
            - {{exp?.end_date}}
          </span>
          <span class="text-9696" *ngIf="exp?.is_primary == true">
            - Current
          </span>

          <!-- </span> -->
        </span>
        <span *ngIf="x == data?.education?.length-1" class="f-12 text-webbtree-green pointer ml-2"
          (click)="viewmoredetails('edu', i , 'less')">
          view less
        </span>
      </div>
    </div>
  </div>

  <!-- skills  -->

  <div class=" d-flex align-items-baseline" *ngIf="showMatchedSkills" style="margin-top: -5px;">
    <div class="d-flex justify-content-end" style="width: 115px;">
      <span class="text-9696 mr-3 f-12">Matched Skills</span>
    </div>
    <div class="d-flex" style="width: 79%;"
      [ngClass]="{'align-items-end':vievmoresoircechip, 'text':vievmoresoircechip}">
      <div class="f-12 d-flex flex-wrap align-items-center">
        <span class="f-14 mb-2" style="min-width: fit-content;"
          *ngFor="let skill of formattedSkills | slice:0:6 let s = index; last as isLast">
          <span class="py-1 mb-1 text-capitalize f-14" [innerHTML]="skill"></span>
          <span *ngIf="!isLast" class="mr-1">,</span>
        </span>
        <span class="f-12 pointer text-webbtree-green ml-2 mb-2" style="min-width: fit-content;"
          *ngIf="otherSkillsLength > 0" (click)="openSliderSection(null, 'show-skills')">
          +{{otherSkillsLength}} Other Skills
        </span>
      </div>
    </div>
    <div class="d-flex align-items-center ml-auto mb-3"
      *ngIf="parent !== 'TalentpoolRecommendedCandidateListComponent'">
      <i class="fa-solid fa-pipe f-20 mr-1" style="color: #ededed;"></i>
      <div class="dstooltip">
        <span (mouseenter)="print()" class="px-2 mb-1 text-capitalize f-12 pointer">Source</span>
        <span class="dstooltip-content source-div-style">
          <app-source-hover-modal [profileInformation]="temp"></app-source-hover-modal>
        </span>
      </div>
    </div>
  </div>



  <!-- activity started -->
  <div *ngIf="showActivity()">
    <hr style="margin-top: 0px;">
    <div class=" d-flex align-items-baseline">
      <div class="d-flex justify-content-end w-100px">
        <span class="text-9696 mr-3 f-12">Activity</span>
      </div>
      <div class="d-flex" style="width:60%">
        <span *ngIf="data && data.talentpoolcount" style="margin-right: 15px;">
          <i class="fas fa-users f-16 text-webbtree-green pointer activity-icon" matTooltip="Added to talentpool"
            [matTooltipClass]="{ 'red-tooltip text-black': true }" matBadge="{{data.talentpoolcount}}"
            matBadgeSize="small" matBadgeOverlap="false" (click)="openSliderSection(null, 'show-activity')"
            style="margin-right: 1px;"></i>
          Talentpool
        </span>
        <span *ngIf="data && data.emailcampaigncount" style="margin-right: 15px;">
          <i class="fa-solid f-16 fa fa-envelope text-webbtree-green pointer activity-icon"
            matTooltip="Added to email campaign" [matTooltipClass]="{ 'red-tooltip text-black': true }"
            matBadge="{{data.emailcampaigncount}}" matBadgeSize="small" matBadgeOverlap="false"
            (click)="openSliderSection(null, 'show-activity')" style="margin-right: 1px;"></i>
          Email Campaign
        </span>

        <span *ngIf="data && data.screenaicount" style="margin-right: 15px;">
          <i class="fa-solid f-16 fa-globe text-webbtree-green pointer activity-icon"
            matTooltip="Added to Screen AI" [matTooltipClass]="{ 'red-tooltip text-black': true }"
            matBadge="{{data.screenaicount}}" matBadgeSize="small" matBadgeOverlap="false"
            (click)="openSliderSection(null, 'show-activity')" style="margin-right: 1px;"></i>
          Screen AI
        </span>
        <span *ngIf="data && data.iswebbtreeverified" class="d-flex align-items-center" style="margin-right: 15px;">
            <span class="pointer mr-1" (click)="openSliderSection(null, 'show-activity')" matTooltip="Webbtree Verified Requested" [matTooltipClass]="{ 'red-tooltip text-black': true }">
              <img style="width: 20px;" src="./../../assets/webbtree_verified.png"/>
            </span>
            Webbtree verified
        </span>
        <span *ngIf="data && data.usedWebbtreeIntroduction" class="d-flex align-items-center" style="margin-right: 15px;">
            <span class="pointer mr-1" (click)="openSliderSection(null, 'show-activity')" matTooltip="Webbtree Introduction Requested" [matTooltipClass]="{ 'red-tooltip text-black': true }">
              <img style="width: 20px;" src="./../../assets/webbtree_verified.png"/>
            </span>
            Webbtree Introduction
        </span>
        <span *ngIf="data && data.unifieddropped">
          <i class="fa-solid fa-puzzle f-16 text-webbtree-green pointer activity-icon" matTooltip="Added to ATS"
            [matTooltipClass]="{ 'red-tooltip text-black': true }" (click)="openSliderSection(null, 'show-activity')"
            style="margin-right: 1px;"></i>
          Added to ATS
        </span>
      </div>
      <p style="justify-content: end; display: flex; width:40%; margin-right: 9px; " class="text-9696 f-12" matTooltip="Last Activity: {{getLastActivity()}}"
            [matTooltipClass]="{ 'red-tooltip text-black': true }"
        *ngIf="(data && data.lastseenbyuser != null) || (data  && data.lastcandidateactivity && data.lastcandidateactivity.length)">
        <i class="fa-regular fa-clock f-12" style="margin-right: 5px;"></i>
        {{getLastActivity()}}
      </p>
    </div>
  </div>

  <!-- activity Ended -->


</div>


<ng-template #addCandidateToEmailCampaign>
  <div class="modal-header b pb-0">
    <h5 class="f-14 font-weight-600" id="experience">Add Candidate to Email Campaign</h5>
    <button data-testid="auto-app-candidate-quick-view-button-2" type="button" class="close font-weight-normal ms-auto btn p-0 f-20"  data-dismiss="modal" aria-label="Close"
      (click)="closeActiveModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-3 pt-0">
    <div class="row mb-2 mt-2">
      <div class="col">
        <input data-testid="auto-app-candidate-quick-view-input-1" type="text" name="campaign_name" class="wc-form-control no-shadow w-100 inputheight mb-2"
          placeholder="Enter Campaign Name...." [formControl]="campaign_input" [matAutocomplete]="campaign_name"
          (input)="onTypeAheadSearch($event.target.value)" (click)="onTypeAheadSearch($event.target.value)" />
        <p *ngIf="campaign_input.errors?.required && (campaign_input.dirty || campaign_input.touched)"
          class="f-12 text-danger">Campaign Name is required</p>
        <mat-autocomplete #campaign_name="matAutocomplete" (optionSelected)="onCampaignSelected($event.option.value)">
          <mat-option *ngFor="let campaign of campaignList" [value]="campaign" [disabled]="campaign.remaining_targets <= 0">
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ campaign.campaign_name }}</span> <span class="badge badge-light border f-12 font-weight-normal text-9696" *ngIf="campaign.remaining_targets <= 0">Campaign limits reached</span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="row mb-0">
      <div class="col d-flex justify-content-end">
        <button data-testid="auto-app-candidate-quick-view-button-3" class="btn-trms-small" (click)="!isLoadingEmailCampaignApi && addToEmailCampaign()"
          [disabled]="!campaign_input.valid">
          <span *ngIf="!isLoadingEmailCampaignApi">Add</span>
          <span *ngIf="isLoadingEmailCampaignApi">
            <img style="width: 20px;" src="../../../assets/rolling-loader-white.gif" alt="">
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addCandidateToScreenAiModal>
  <div class="modal-content">
    <div class="modal-header b pb-0">
      <h5 class="f-14 font-weight-600" id="downloadCSVModalHeading">Add to Screen AI</h5>
      <button data-testid="auto-app-candidate-quick-view-button-4" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
        (click)="closeActiveModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pb-3 pt-0">
      <div *ngIf="!screenAiDuplicateCheckDone">
        <div class="row mb-2 mt-2">
          <div class="col">
            <input data-testid="auto-app-candidate-quick-view-input-2"
              type="text"
              class="wc-form-control no-shadow w-100 inputheight mb-2"
              placeholder="Enter Job Name...."
              [formControl]="job_input"
              [matAutocomplete]="job_name"
              (click)="getAllScreenAIJobs()"
            />
            <p *ngIf="job_input.errors?.required && (job_input.dirty || job_input.touched)"
                    class="f-12 text-danger">Job Name is required</p>
            <mat-autocomplete #job_name="matAutocomplete" (optionSelected)="onJobSelected($event.option.value)">
              <mat-option *ngFor="let job of jobList" [value]="job" [disabled]="isScreeningInProgress(job)" [matTooltip]="getTooltipText(job)" [matTooltipClass]="{ 'eu-tooltip text-black': true }" matTooltipPosition="above">
                {{ job.name }} <span class="float-right text-right ml-auto f-12 mt-2 text-9696" *ngIf="job.batch_status === 'pending'">Screening in progress</span>
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
        <div class="row mb-0">
          <div class="col  d-flex justify-content-end">
            <button data-testid="auto-app-candidate-quick-view-button-5" class="btn-trms-small" (click)="!isLoadingScreenAiApi && addToScreenAi()" [disabled]="!job_input.valid">
              <span *ngIf="!isLoadingScreenAiApi">
                Add
              </span>
              <span *ngIf="isLoadingScreenAiApi">
                <img style="width: 20px;" src="../../../assets/rolling-loader-white.gif" alt="">
              </span>
            </button>
          </div>
        </div>
        </div>
      <ng-container *ngIf="screenAiDuplicateCheckDone">
        <div class="px-3">
          <p>{{postAddMssg}}</p>
          <div class="float-right d-flex flex-row justify-content-end mb-2">
            <button data-testid="auto-app-candidate-quick-view-button-6" class="outlined-button" *ngIf="addCandidateSuccess" style="width: fit-content; padding: 1rem; border-radius: .3125rem;" (click)="redirectToScreenAi()">
              View Screen AI
            </button>
            <button data-testid="auto-app-candidate-quick-view-button-7"  (click)="closeActiveModal()" class="ml-2 enabled-button" style="width: fit-content; padding: 1rem; border-radius: .3125rem;">
              <span *ngIf="addCandidateSuccess" (click)="ngOnInit()">Continue Search</span>
              <span *ngIf="!addCandidateSuccess">Close</span>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
    </div>
</ng-template>
<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>
<ngb-alert class="ngb-alert error-message-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ng-template #addToEmailCampaignWithViewCampaign let-modal>
  <div class=" p-2 text-white" style="background-color: #53EBA4;">
    <p class="mb-0 d-flex align-items-center"><span><i class="fa-solid fa-check mx-2 text-white f-18"></i></span> <span>Profile added to Campaign</span><span class="text-truncate pointer font-weight-600" style="text-decoration: underline;" (click)="redirectToEmailCampaign(selectedCampaign?.campaign_id)">"{{campaignName}}".</span></p>
  </div>
</ng-template>
